const UserPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID || '';
const ClientId = process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || '';

export const poolData = {
  UserPoolId,
  ClientId
};

export const amplifyAuthConfig = {
  Auth: {
    Cognito: {
      userPoolId: UserPoolId,
      userPoolClientId: ClientId
    }
  }
};
